/*
 * Workflow step module which can trigger subscribers when the selected step action changes
*/

rs.module("framework/content/workflow/step",

    [],

    function () {

        var _stepAction;
        var _stepActions;
        var _onStepActionChangedHandlers = [];

        //
        // Initialize
        //
        function initialize(jsSelectors, stepActions) {

            _stepAction = $.js(jsSelectors.stepAction);
            _stepActions = stepActions;

            // When the step action changes, notify listeners
            _stepAction.on("change", function () {

                _callStepActionChanged($(this).val());
            });

            // fire the change handler immediately so listeners can initialize themselves
            _callStepActionChanged(_stepAction.val());

            function _callStepActionChanged(value) {

                _onStepActionChangedHandlers.forEach(function (handler) {
                    handler(value);
                });
            }
        }

        //
        // Attach a handler for being notified when step action changes
        // 
        function onStepActionChanged(handler) {
            _onStepActionChangedHandlers.push(handler);
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            onStepActionChanged: onStepActionChanged
        };

        // Expose all step action values as a readonly property
        Object.defineProperty(exports, "stepActions",
            {
                get: () => _stepActions,
            });


        return exports;
    }
);